import * as React from 'react';
import { observer } from 'mobx-react';
import { Notice } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';

interface SearchNotFoundNoticeProps {
  customType?: string;
}

function SearchNotFoundNotice(props: SearchNotFoundNoticeProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;
  const { customType } = props;
  return (
    <Notice size="small" align="center">
      {translate(`search.notFound${customType ? `.${customType}` : ''}`)}
    </Notice>
  );
}

export default observer(SearchNotFoundNotice);
